// Stats-Compare — scroll-triggers the per-dot staggered reveal (transition-delay set per dot in the PHP/SCSS).
import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	var targets = document.querySelectorAll('[data-p360-observe]');
	if (!targets.length || !('IntersectionObserver' in window)) {
		return;
	}

	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.12 });

	targets.forEach(function (el) {
		observer.observe(el);
	});
});